import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { DEFAULTS } from "@/content/schema";

const ContentCtx = createContext({ values: DEFAULTS, ready: false });

export function ContentProvider({ children }) {
  const [values, setValues] = useState(DEFAULTS);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    api.get("/content")
      .then((r) => setValues({ ...DEFAULTS, ...(r.data || {}) }))
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);
  const ctx = useMemo(() => ({ values, ready }), [values, ready]);
  return <ContentCtx.Provider value={ctx}>{children}</ContentCtx.Provider>;
}

export function useContent() {
  const { values, ready } = useContext(ContentCtx);
  const t = (key, vars) => {
    let s = values[key] ?? DEFAULTS[key] ?? "";
    if (vars) Object.entries(vars).forEach(([k, v]) => { s = s.split(`{${k}}`).join(v); });
    return s;
  };
  const list = (key) => t(key).split("\n").map((x) => x.trim()).filter(Boolean);
  return { t, list, ready };
}

/* CMS image: cream placeholder until content is loaded, then fade-in (avoids flashing the default image) */
export function CmsImg({ imgKey, alt, className = "", fetchPriority }) {
  const { t, ready } = useContent();
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`relative bg-cream ${className}`}>
      {ready && (
        <img
          src={t(imgKey)}
          alt={alt}
          fetchPriority={fetchPriority}
          onLoad={() => setLoaded(true)}
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${loaded ? "opacity-100" : "opacity-0"}`}
        />
      )}
    </div>
  );
}

/* Renders "texte *mot en italique* texte" with <em> */
export function Em({ children, className = "text-teal" }) {
  const parts = String(children).split("*");
  return parts.map((p, i) => (i % 2 === 1 ? <em key={`${i}-${p}`} className={className}>{p}</em> : p));
}
